import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import { EpiApiState, epiApiReducerWithDefault } from '../global/ducks/epi-api';
import { IEpiProps } from './state-helpers/epi-props';
import { defaultEpiPropsModel } from './reducers/epi-props-model';
import { fetchMiddleware } from '../global/middleware/fetch-middleware';
import { RestrictedContentFormApp } from './components/restricted-content-form-app';
import { FilterableListApiState, filterableListApiReducer } from '../global/ducks/filterable-list-api';
import { RouterToUrlQuery, addUrlProps, UrlQueryParamTypes, subquery, configureUrlQuery, urlQueryMiddleware } from 'react-url-query';
import { BrowserRouter, Route } from 'react-router-dom';
import { history } from './state-helpers/history';
import { createRoot } from 'react-dom/client';


// State that controls this app
export interface IBaseAppState {
    epi: EpiApiState<IEpiProps>,
}

export const stateReducer = combineReducers<IBaseAppState>({
    epi: epiApiReducerWithDefault({ props: defaultEpiPropsModel }),
});

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateStore = createStore(stateReducer, composeEnhancers(
    applyMiddleware(
        fetchMiddleware,
        urlQueryMiddleware()
    )
));
const RouterContext = React.createContext({});

configureUrlQuery({ history, addChangeHandlers: false });

const restrictedContentFormApp = document.getElementById('restricted-content-form-app');

if (restrictedContentFormApp) {
    const restrictedContentFormRoot = createRoot(restrictedContentFormApp);
    const { contentId, } = (window as any).bootstrap;

    restrictedContentFormRoot.render(
        <Provider store={stateStore}>
            <BrowserRouter>
                <Route>
                    {routeProps => (
                        <RouterContext.Provider value={routeProps}>
                            <RouterToUrlQuery routerContext={RouterContext}>
                    <RestrictedContentFormApp
                        contentId={contentId}
                    />
                </RouterToUrlQuery>
                        </RouterContext.Provider>
                    )}
                </Route>
            </BrowserRouter>
        </Provider>)
}